import { z } from 'zod';
export const createOutshipmentSchema = z.object({
    delivery_no: z.string().nullable().optional(),
    shipping_code: z.string().min(1, 'Shipping method is required'),
    product_code: z.string().min(1, 'Product code is required'),
    quantity: z.number().positive('Quantity must be greater than 0'),
    ship_to_name: z.string().min(1, 'Ship to name is required'),
    ship_to_name2: z.string().nullable().optional(),
    ship_to_address1: z.string().min(1, 'Address is required'),
    ship_to_address2: z.string().nullable().optional(),
    ship_to_city: z.string().min(1, 'City is required'),
    ship_to_state: z.string().min(1, 'State is required'),
    ship_to_zip: z.string().min(1, 'ZIP code is required'),
    ship_to_country: z.string().min(1).default('US'),
    from_account_id: z.number().int().positive().nullable().optional(),
    notes: z.string().nullable().optional(),
});
export const updateOutshipmentSchema = createOutshipmentSchema.partial();
//# sourceMappingURL=outshipment.js.map